import React, { useState, useEffect } from "react";
import instance from "../../api/api";
import InputCreate from "../../features/InputCreate";
// import { Help } from "../../utils";
import Swal from "sweetalert2";
// import { Tabs } from 'antd';
import withReactContent from "sweetalert2-react-content";
// import { TabView, TabPanel } from "primereact/tabview";
import Button from "../../features/Button";
import { Header } from "../../shared/compoments";
// import { MultiSelect } from 'primereact/multiselect';
// import { Dropdown } from "primereact/dropdown";
// import useDebounce from "../../hooks/useDebounce";
// import { TabView, TabPanel } from 'primereact/tabview';
function SaveCommune() {
  const styleBtn = {
    padding: ".5em",
    borderRadius: "5px",
    fontWeight: "bold",
    cursor: "pointer",
    color: "black",
    backgroundColor: "rgb(255 177 47 / 99%)",
    marginTop: "1em",
    border: "none",
  };
  const MySwal = withReactContent(Swal);
  // const [isServices, setIsServices] = useState("services");
  const [data, setData] = useState({
    name: "",
  });
  const [dataCommune, setDataCommune] = useState({
    city_id: "",
    name: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [allVille, setAllVille] = useState([]);
  const [seeModalVille, setSeeModalVille] = useState(false);

  const createMunicipalite = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const data = {
      city_id: dataCommune.city_id,
      names: [dataCommune.name],
    };
    try {
      const responseMunicipalite = await instance.post("municipalite", data);
      if (responseMunicipalite.data.status) {
        MySwal.fire({
          title: "Commune enrégistrée",
          icon: "info",
          showConfirmButton: true,
        });
        setIsLoading(false);
      }
      console.log(responseMunicipalite.data.data);
    } catch (error) {
      console.log(error);
      let msgError = [];
      for (const property in error.response.data.message) {
        msgError = [...msgError, error.response.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
      setIsLoading(false);
    }
  };
  const createCities = async (e) => {
    e.preventDefault();
    try {
      const response = await instance.post("cities", data);
      console.log(response.data.data);
      MySwal.fire({
        title: "Ville enrégistrée",
        icon: "info",
        showConfirmButton: true,
      });
      getListVilles();
      setSeeModalVille(false);
    } catch (error) {
      console.log(error);
      let msgError = [];
      for (const property in error.response.data.message) {
        msgError = [...msgError, error.response.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
    }
  };
  const getListVilles = async () => {
    try {
      const response = await instance.get("cities");
      setAllVille(response?.data.data);
      console.log("response.data.data", response?.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  // const handlePrice = (value) => {
  //   console.log(value);
  //   setPrixActuelService(Number(value.tarif || value.prix));
  //   console.log("prixActuelService", prixActuelService);
  // };

  // useEffect(() => {
  //   function handlePricePromotion(value) {
  //     console.log("handlePricePromotion", value);
  //     const valueAfterPercent = (value * prixActuelService) / 100;
  //     const priceForPromotions = prixActuelService - valueAfterPercent;
  //     setPrixActuelPromotions(priceForPromotions);
  //     console.log("valueAfterPercent", valueAfterPercent);
  //     console.log("priceForPromotions", priceForPromotions);
  //   }
  //   if (debouncedValue) {
  //     console.log("Debounced Value:", debouncedValue);
  //     handlePricePromotion(debouncedValue);
  //   }
  // }, [debouncedValue, prixActuelService]);
  useEffect(() => {
    getListVilles();
  }, []);

  return (
    <div>
      <Header libelle={"Enregistrer une commune"} />
      {/* {seeModalVille && (
        <div className="conteneur_add_ville create-user">
          <div className="add_ville ">
            <div className="d-flex justify-content-between align-items-center gap-3">
              <h3>Enregistrer une ville</h3>
              <h4
                className="close_add_ville"
                onClick={() => setSeeModalVille(false)}>
                x
              </h4>
            </div>
            <InputCreate
              label="Ville"
              typeInput="text"
              nameInput="ville"
              active={true}
              getValue={(e) => {
                setData({ ...data, name: e.target.value });
              }}
              dataValue={data.name}
            />
            <div className="d-flex justify-content-end">
              <button
                className="btn bg-primary text-light"
                type="submit"
                onClick={createCities}>
                Ajouter
              </button>
            </div>
          </div>
        </div>
      )} */}
      <form onSubmit={createMunicipalite} className="px-3 my-3">
        <div className="row g-3">
          {/* Sélection de la ville */}
          <div className="col-lg-6">
            <label htmlFor="city_id" className="form-label fw-semibold">
              Sélectionner une ville
            </label>
            <select
              id="city_id"
              className="form-select"
              value={dataCommune.city_id}
              onChange={(e) => {
                setDataCommune({ ...dataCommune, city_id: e.target.value });
              }}
              required>
              <option value="" disabled>
                Choisir une ville
              </option>
              {allVille.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          {/* Champ Commune */}
          <div className="col-lg-6">
            <InputCreate
              label="Commune"
              typeInput="text"
              nameInput="commune"
              active={true}
              placeholder="Ex: Cocody"
              getValue={(e) => {
                setDataCommune({ ...dataCommune, name: e.target.value });
              }}
              dataValue={dataCommune.name}
            />
          </div>

          {/* Bouton Enregistrer */}
          <div className="col-lg-6 d-flex align-items-end">
            <Button
              titre="Enregistrer"
              styleBtn={styleBtn}
              isLoading={isLoading}
            />
          </div>
        </div>
      </form>
      {/* <form onSubmit={createMunicipalite} className="px-3 my-3">
        <div className="my-4">
          <label htmlFor="promotions_services">Séléctionner une ville</label>
          <select
            name=""
            id="promotions_services"
            className="p-3 w-100 rounded"
            value={data.city_id}
            onChange={(e) => {
              setDataCommune({ ...data, city_id: e.target.value });
            }}>
            <option value="" disabled>
              Choisir une Ville
            </option>
            {allVille.map((item) => (
              <option key={item.id} value={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
        <InputCreate
          label="Commune"
          typeInput="text"
          nameInput="Commune"
          active={true}
          getValue={(e) => {
            setDataCommune({ ...dataCommune, name: e.target.value });
          }}
          dataValue={dataCommune.name}
        />
        <div>
          <Button
            titre="Enregistrer"
            styleBtn={styleBtn}
            isLoading={isLoading}
          />
        </div>
      </form> */}
    </div>
  );
}

export default SaveCommune;
